const generalColumnProps = {
  sortable: true,
  resizable: false,
  disableColumnMenu: true,
  flex: 1,
  minWidth: 120,
  maxWidth: 120,
};

export default generalColumnProps;
